"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarProjectSwitcherComponent = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const ProjectsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/ProjectsProvider");
const react_router_dom_1 = require("react-router-dom");
const antd_1 = require("antd");
const icons_1 = require("@ant-design/icons");
const AppRouting_1 = require("src/hello_assets/src/components/system/AppRouting");
const lodash_1 = __importDefault(require("lodash"));
const CurrentProjectProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/CurrentProjectProvider");
const ActorTransportParametersTransformations_1 = require("src/hello_assets/src/components/system/actor/ActorTransportParametersTransformations");
const TextTruncated_1 = require("src/hello_assets/src/components/ui/common/common/TextTruncated");
const ProjectModalComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/ProjectModalComponent");
const isMounted_1 = __importDefault(require("src/hello_assets/src/components/system/isMounted"));
const ToolbarProjectSwitcherComponent = ({}) => {
    const isMounted = (0, isMounted_1.default)();
    const history = (0, react_router_dom_1.useHistory)();
    const projectsContext = (0, ProjectsProvider_1.useProjectsContext)();
    const currentProjectContext = (0, CurrentProjectProvider_1.useCurrentProjectContext)();
    const [createProjectModalVisible, setCreateProjectModalVisible] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), { visible: false, nonce: 0 });
    const onCreateProjectModalDestroy = (0, react_1.useCallback)(() => {
        if (isMounted()) {
            setCreateProjectModalVisible({ visible: false });
        }
    }, [isMounted]);
    const [state, setState] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), {
        createProjectInProgress: false,
        dropdownVisible: false
    });
    const projectsState = projectsContext.projectsState;
    if (!projectsState.loaded) {
        return null;
    }
    const thereIsNoProjects = lodash_1.default.isEmpty(projectsState.data);
    let buttonLabel = "Select Project";
    let selectedProjectApiKey = undefined;
    if (!lodash_1.default.isNil(currentProjectContext)) {
        selectedProjectApiKey = currentProjectContext.projectApiKey;
        buttonLabel = ActorTransportParametersTransformations_1.ActorTransportParametersTransformations.Project.projectName(currentProjectContext, lodash_1.default.indexOf(lodash_1.default.map(projectsState.data, "view.projectApiKey"), currentProjectContext.projectApiKey));
    }
    const onClickMenu = async ({ key }) => {
        if (lodash_1.default.isEqual("create", key)) {
            setState({
                dropdownVisible: false
            });
            setCreateProjectModalVisible({ visible: true, nonce: createProjectModalVisible.nonce + 1 });
        }
        else {
            setState({
                dropdownVisible: false
            });
            const url = AppRouting_1.AppPathGenerator.Project.home(key);
            history.push(url);
        }
    };
    const onVisibleChangeDropdown = (visible) => {
        setState({ dropdownVisible: visible });
    };
    const items = [];
    items.push(...projectsState.data.map(({ view: projectProfileView }, projectIndex) => {
        const projectApiKey = projectProfileView.projectApiKey;
        const projectTitle = ActorTransportParametersTransformations_1.ActorTransportParametersTransformations.Project.projectName(projectProfileView, projectIndex);
        const isTheSame = lodash_1.default.isEqual(projectApiKey, selectedProjectApiKey);
        const projectTitleElement = React.createElement(TextTruncated_1.TextTruncated, { text: projectTitle, length: 60 });
        return {
            key: projectApiKey,
            label: React.createElement(React.Fragment, null, projectTitleElement),
            disabled: isTheSame
        };
    }));
    if (!thereIsNoProjects) {
        items.push({ type: "divider" });
    }
    items.push({ key: "create", label: React.createElement(antd_1.Button, { type: "link", className: "ug-text ug-text-full-width", loading: state.createProjectInProgress, disabled: state.createProjectInProgress }, "Create Project") });
    const menu = React.createElement(antd_1.Menu, { onClick: onClickMenu, items: items });
    return React.createElement(React.Fragment, null,
        React.createElement(antd_1.Dropdown, { overlay: menu, trigger: ["click"], placement: "bottomRight", onVisibleChange: onVisibleChangeDropdown, visible: state.dropdownVisible },
            React.createElement(antd_1.Button, { disabled: true, type: "link", className: "projectSwitcher" },
                React.createElement("span", { className: "projectSwitcherLabel" },
                    React.createElement(TextTruncated_1.TextTruncated, { text: buttonLabel, length: 60 })),
                " ",
                React.createElement(icons_1.DownOutlined, null))),
        React.createElement(ProjectModalComponent_1.ProjectModalComponent, { key: createProjectModalVisible.nonce, visible: createProjectModalVisible.visible, onDestroy: onCreateProjectModalDestroy, ctx: "projectSwitcher" }));
};
exports.ToolbarProjectSwitcherComponent = ToolbarProjectSwitcherComponent;
